import get from 'lodash/get';

import { SEARCH_REQUESTED, SEARCH_COMPLETED } from '../redux/search';

// import { SearchTracker, SearchCompletedTracker } from '../types/tracking';

import type { EventTracking, SearchRequested, SearchCompleted } from '../types';

export const pbr_search_requested = 'pbr_search_requested';
export const pbr_search_completed = 'pbr_search_completed';

let lastCompletedSearchTerm = undefined;

function searchRequested(
  action: SearchRequested,
  store: Object,
): SearchTracker {
  return {
    entry_point: get(store, 'search.tracking.entry_point'),
    searched_for: get(store, 'search.tracking.searched_for'),
  };
}

function searchCompleted(
  action: SearchCompleted,
  store: Object,
): SearchCompletedTracker {
  return {
    entry_point: get(store, 'search.tracking.entry_point'),
    searched_for: get(store, 'search.tracking.searched_for'),
    index: action.payload.currentPage,
    search_count: action.payload.total,
  };
}

export function validateSearchCompleted(action: Object): boolean {
  // Valid only if the page name has changed
  let isNewSearchTerm = action.data.searched_for !== lastCompletedSearchTerm;
  lastCompletedSearchTerm = action.data.searched_for;
  return isNewSearchTerm;
}

// Make sure you cast this before you export it in your duckling;
// we have to verify type BEFORE we leave the execution context of this module.
//
// The best way to do this is actually to create the object
// and do each assignment individually... for now.

const tracking: EventTracking = {};
tracking[SEARCH_REQUESTED] = searchRequested;
tracking[SEARCH_COMPLETED] = searchCompleted;

export default tracking;
